module.exports = {"AVENIR_ROMAN":"Avenir-Roman","AVENIR_BLACK":"Avenir-Black","AVENIR_BOOK":"Avenir-Book","AVENIR_HEAVY":"Avenir-Heavy","AVENIR_MEDIUM":"Avenir-Medium","ROBOTOMONO_REGULAR":"RobotoMono-Regular","ROBOTOMONO_BOLD":"RobotoMono-Bold"}


//////////////////
// WEBPACK FOOTER
// ./res/fontStyle.json
// module id = 4
// module chunks = 0